const months = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

const MapCards = (props) => {
	const today = new Date();
	const pricingUnit = localized_params.price_unit;

	if (props.mapEvents === null) {
		return;
	}

	props.mapEvents.sort((a, b) => {
		return a.startDate < b.startDate ? -1 : 1;
	});

	return (
		<>
			{props.mapEvents && props.mapEvents.map((event) => {
				const startMonth = months[event.startDate.getMonth()];
				const endMonth = months[event.endDate.getMonth()];

				const closed = event.status == 'closed';
				const earlyBird = event.early_bird_price && event.earlyDate >= today;
				const SALE = Boolean(event.sale_price);

				return (
					<div
						key={event.ID}
						className={"wtrmap-card" + (closed ? ' wtrmap-card-closed' : '') + (earlyBird ? ' wtrmap-card-earlybird' : '') + (SALE ? ' wtrmap-card-sale' : '')}
						onClick={() => props.clickKeyHandler(event.ID)}
						onKeyDown={() => props.clickKeyHandler(event.ID)}
						role="presentation"
						>

						<h3 class="wtrmap-card-title">{event.title}</h3>

						<div class="wtrmap-card-icon wtrmap-card-date">
							{startMonth} {event.startDate.getDate()}-{startMonth != endMonth ? endMonth + ' ' : ''}{event.endDate.getDate()}, {event.startDate.getFullYear()}
						</div>

						<div class="wtrmap-card-icon wtrmap-card-location">
							<div class="wtrmap-card-hotel">{event.location}</div>
							<div class="wtrmap-card-city-state">{event.city}, {event.state}</div>
						</div>

						<div class="wtrmap-card-icon wtrmap-card-prices">
							<span class="wtrmap-card-price wtrmap-card-price-regular">${event.price} <span class="price-unit">{pricingUnit}</span></span>
							{earlyBird &&
								<span class="wtrmap-card-price wtrmap-card-price-earlybird"> ${event.early_bird_price} <span class="price-unit">{pricingUnit}</span></span>
							}
							{SALE &&
								<span class="wtrmap-card-price wtrmap-card-price-sale"> ${event.sale_price} <span class="price-unit">{pricingUnit}</span></span>
							}
						</div>

						<a href={event.link} target="_blank" class="wtrmap-card-button">{closed ? 'View Event Details' : 'Register Today'}</a>

					</div>
				);
			})
			}
		</>
	);
}

export { MapCards };
